import axios from 'axios';
import { T3_HOST, T3_DEFAULT_PARAMS, GET_BUILDINGS } from './const';

const getBuildings = () => {
  const url = `${T3_HOST}${T3_DEFAULT_PARAMS}`;
  const request = axios.get(url);

  return {
    type: GET_BUILDINGS,
    payload: request,
  };
};

export default getBuildings;
